// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1QFFr","modalForm":"UpgradeEpcsModal_modalForm__2yy0d","modalFooter":"UpgradeEpcsModal_modalFooter__dV2fq"};